import businessClient from 'src/services/clients/business'
import { IMeta, IRole, IConfig } from 'src/common/interfaces/index.js'

const IStaffRoleListResponse = { meta: IMeta, data: { list: [IRole] } }
const IStaffConfigResponse = { meta: IMeta, data: { list: [IConfig] } }

export const staffRole = {
  /**
   * @param {id: number} filter
   * @return {IStaffRoleListResponse}
   */
  list(filter, signal) {
    return businessClient().post('staff/roles/portal/list', { filter }, { signal })
  },

  /**
   * @param {IStaff} data
   * @return {upsert: [IRole]}
   */
  upsert(data, signal) {
    return businessClient().post('staff/roles/upsert', { data }, { signal })
  },

  /**
   * @param { id: number} filter
   * @return {IRole}
   */
  archive(filter, signal) {
    return businessClient().post('staff/roles/archive', { filter }, { signal })
  },

  /**
   * @param {}
   * @return {IStaffConfigResponse}
   */
  config(signal) {
    return businessClient().post('staff/roles/config', {}, { signal })
  },
}
